module.exports = __webpack_public_path__ + "static/media/mobile-clock-wallpaper.27ce352d.jpg";